import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7554f3b0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "infoContent"
};
const _hoisted_2 = {
  key: 0,
  class: "header"
};
const _hoisted_3 = {
  class: "name"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "设备名：", -1));
const _hoisted_5 = {
  key: 1,
  class: "main"
};
const _hoisted_6 = {
  class: "list_item"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  key: 1,
  class: "remainBattery"
};
const _hoisted_9 = {
  key: 2
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_space = _resolveComponent("el-space");
  const _component_AddressLabel = _resolveComponent("AddressLabel");
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_List = _resolveComponent("List");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.info ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_space, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createTextVNode(_toDisplayString(_ctx.info.name), 1)])]),
    _: 1
  })])) : _createCommentVNode("", true), _ctx.info ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_List, {
    list: _ctx.contents,
    idKey: "label",
    liHover: false
  }, {
    default: _withCtx(({
      item
    }) => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(item.label), 1), item.contentSlot === 'address' ? (_openBlock(), _createBlock(_component_AddressLabel, {
      key: 0,
      point: _ctx.info.point
    }, null, 8, ["point"])) : item.contentSlot === 'remainBattery' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_progress, {
      "text-inside": true,
      "stroke-width": 16,
      percentage: item.content,
      status: "success"
    }, null, 8, ["percentage"])])) : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(item.content), 1))])]),
    _: 1
  }, 8, ["list"])])) : _createCommentVNode("", true)]);
}